import { emptySplitApi as api } from './emptyApi';
export const addTagTypes = ['messages'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      messagesMessageSettingsRetrieve: build.query<
        MessagesMessageSettingsRetrieveApiResponse,
        MessagesMessageSettingsRetrieveApiArg
      >({
        query: () => ({ url: `/messages/message-settings/` }),
        providesTags: ['messages'],
      }),
      messagesMessageSettingsUpdate: build.mutation<
        MessagesMessageSettingsUpdateApiResponse,
        MessagesMessageSettingsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/message-settings/`,
          method: 'PUT',
          body: queryArg.messageSettings,
        }),
        invalidatesTags: ['messages'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as bambiApi };
export type MessagesMessageSettingsRetrieveApiResponse =
  /** status 200  */ MessageSettings;
export type MessagesMessageSettingsRetrieveApiArg = void;
export type MessagesMessageSettingsUpdateApiResponse =
  /** status 200  */ MessageSettings;
export type MessagesMessageSettingsUpdateApiArg = {
  messageSettings: MessageSettings;
};
export type PickupMessageModeEnum = 'near-pickup' | 'before-pickup-time';
export type TripAcknowledgementMessageModeEnum = 'same-day' | 'any-day';
export type MessageSettings = {
  pickup_message_mode?: PickupMessageModeEnum;
  /** The number of seconds to send the message before the pickup time. */
  seconds_to_send_message_before_pickup_time?: number;
  /** The mode to send the trip acknowledgement message in. If same-day the message will only be sent for trips scheduled for today. Otherwise, the message will be sent for trips scheduled for any day. */
  trip_acknowledgement_message_mode?: TripAcknowledgementMessageModeEnum;
  /** Whether to enable the pickup message. */
  enable_pickup_message?: boolean;
  /** Whether to enable the trip acknowledgement message. */
  enable_trip_acknowledgement_message?: boolean;
  /** Whether to enable the reminder message. */
  enable_reminder_message?: boolean;
  /** Whether to enable the public trip portal message. */
  enable_public_trip_portal_message?: boolean;
  /** Whether to enable the trip canceled message. */
  enable_trip_canceled_message?: boolean;
};
export type ClientErrorEnum = 'client_error';
export type ParseErrorCodeEnum = 'parse_error';
export type ParseError = {
  code: ParseErrorCodeEnum;
  detail: string;
  attr: string | null;
};
export type ParseErrorResponse = {
  type: ClientErrorEnum;
  errors: ParseError[];
};
export type MessagesMessageSettingsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type ErrorCode403Enum = 'permission_denied';
export type Error403 = {
  code: ErrorCode403Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse403 = {
  type: ClientErrorEnum;
  errors: Error403[];
};
export type ErrorCode404Enum = 'not_found';
export type Error404 = {
  code: ErrorCode404Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse404 = {
  type: ClientErrorEnum;
  errors: Error404[];
};
export type ValidationErrorEnum = 'validation_error';
export type MessagesMessageSettingsUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type MessagesMessageSettingsUpdatePickupMessageModeErrorComponent = {
  attr: 'pickup_message_mode';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MessagesMessageSettingsUpdateSecondsToSendMessageBeforePickupTimeErrorComponent =
  {
    attr: 'seconds_to_send_message_before_pickup_time';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type MessagesMessageSettingsUpdateTripAcknowledgementMessageModeErrorComponent =
  {
    attr: 'trip_acknowledgement_message_mode';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type MessagesMessageSettingsUpdateEnablePickupMessageErrorComponent = {
  attr: 'enable_pickup_message';
  code: 'invalid' | 'null';
  detail: string;
};
export type MessagesMessageSettingsUpdateEnableTripAcknowledgementMessageErrorComponent =
  {
    attr: 'enable_trip_acknowledgement_message';
    code: 'invalid' | 'null';
    detail: string;
  };
export type MessagesMessageSettingsUpdateEnableReminderMessageErrorComponent = {
  attr: 'enable_reminder_message';
  code: 'invalid' | 'null';
  detail: string;
};
export type MessagesMessageSettingsUpdateEnablePublicTripPortalMessageErrorComponent =
  {
    attr: 'enable_public_trip_portal_message';
    code: 'invalid' | 'null';
    detail: string;
  };
export type MessagesMessageSettingsUpdateEnableTripCanceledMessageErrorComponent =
  {
    attr: 'enable_trip_canceled_message';
    code: 'invalid' | 'null';
    detail: string;
  };
export type MessagesMessageSettingsUpdateError =
  | ({
      attr: 'non_field_errors';
    } & MessagesMessageSettingsUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickup_message_mode';
    } & MessagesMessageSettingsUpdatePickupMessageModeErrorComponent)
  | ({
      attr: 'seconds_to_send_message_before_pickup_time';
    } & MessagesMessageSettingsUpdateSecondsToSendMessageBeforePickupTimeErrorComponent)
  | ({
      attr: 'trip_acknowledgement_message_mode';
    } & MessagesMessageSettingsUpdateTripAcknowledgementMessageModeErrorComponent)
  | ({
      attr: 'enable_pickup_message';
    } & MessagesMessageSettingsUpdateEnablePickupMessageErrorComponent)
  | ({
      attr: 'enable_trip_acknowledgement_message';
    } & MessagesMessageSettingsUpdateEnableTripAcknowledgementMessageErrorComponent)
  | ({
      attr: 'enable_reminder_message';
    } & MessagesMessageSettingsUpdateEnableReminderMessageErrorComponent)
  | ({
      attr: 'enable_public_trip_portal_message';
    } & MessagesMessageSettingsUpdateEnablePublicTripPortalMessageErrorComponent)
  | ({
      attr: 'enable_trip_canceled_message';
    } & MessagesMessageSettingsUpdateEnableTripCanceledMessageErrorComponent);
export type MessagesMessageSettingsUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: MessagesMessageSettingsUpdateError[];
};
export type MessagesMessageSettingsUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MessagesMessageSettingsUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export const {
  useMessagesMessageSettingsRetrieveQuery,
  useLazyMessagesMessageSettingsRetrieveQuery,
  useMessagesMessageSettingsUpdateMutation,
} = injectedRtkApi;
